const SF36_ID = 'b7598e4a-d85d-47ed-81ee-71a62bffa221';

// Recodificação de itens específicos — identificados pela ordem do campo
const RECODE = {
  1:  { 1:5, 2:4, 3:3, 4:2, 5:1 },
  20: { 1:5, 2:4, 3:3, 4:2, 5:1 },
  21: { 1:6, 2:5.4, 3:4.2, 4:3.1, 5:2, 6:1 },
  22: { 1:6, 2:4.75, 3:3.5, 4:2.25, 5:1 },
  23: { 1:6, 2:5, 3:4, 4:3, 5:2, 6:1 },
  26: { 1:6, 2:5, 3:4, 4:3, 5:2, 6:1 },
  27: { 1:6, 2:5, 3:4, 4:3, 5:2, 6:1 },
  30: { 1:6, 2:5, 3:4, 4:3, 5:2, 6:1 },
  33: { 1:5, 2:4, 3:3, 4:2, 5:1 },
  35: { 1:5, 2:4, 3:3, 4:2, 5:1 },
};

// Ordens dos campos de cada domínio (Ciconelli et al., 1999)
const DOMINIOS_ORDENS = {
  CF:  [3,4,5,6,7,8,9,10,11,12],
  AF:  [13,14,15,16],
  DOR: [21,22],
  EGS: [1,33,34,35,36],
  VIT: [23,27,29,31],
  AS:  [20,32],
  AE:  [17,18,19],
  SM:  [24,25,26,28,30],
};

// Min/max por item individual de cada domínio (após recodificação)
// Usado para escalar proporcionalmente quando há campos não respondidos
const DOMINIO_PER_ITEM = {
  CF:  { min: 1, max: 3 },
  AF:  { min: 1, max: 2 },
  DOR: { min: 1, max: 6 },
  EGS: { min: 1, max: 5 },
  VIT: { min: 1, max: 6 },
  AS:  { min: 1, max: 5 },
  AE:  { min: 1, max: 2 },
  SM:  { min: 1, max: 6 },
};

export const DOMINIO_LABELS = {
  CF:  'Capacidade Funcional',
  AF:  'Aspectos Físicos',
  DOR: 'Dor',
  EGS: 'Estado Geral de Saúde',
  VIT: 'Vitalidade',
  AS:  'Aspectos Sociais',
  AE:  'Aspectos Emocionais',
  SM:  'Saúde Mental',
};

export function isSF36(score) {
  return score?.id === SF36_ID;
}

/**
 * Calcula os 8 domínios do SF-36.
 * @param {Object} respostas - { [campo_id]: valor_bruto }
 * @param {Array}  campos    - array de score_campos do banco (com id e ordem)
 * @returns {Object} { CF, AF, DOR, EGS, VIT, AS, AE, SM }
 *   Cada domínio: { score: number|null, label: string, camposUsados: number, camposTotais: number }
 */
export function calcularDominiosSF36(respostas, campos) {
  // Mapa ordem → campo_id para acesso rápido
  const ordemMap = {};
  campos.forEach(c => { ordemMap[c.ordem] = c.id; });

  const result = {};

  for (const [dominio, ordens] of Object.entries(DOMINIOS_ORDENS)) {
    const { min: perMin, max: perMax } = DOMINIO_PER_ITEM[dominio];
    const camposTotais = ordens.length;
    let rawSum = 0;
    let camposUsados = 0;

    for (const ordem of ordens) {
      const campoId = ordemMap[ordem];
      if (!campoId) continue;
      const rawVal = respostas[campoId];
      if (rawVal === undefined || rawVal === null || rawVal === '') continue;

      const recode = RECODE[ordem];
      const recodedVal = recode
        ? (recode[Number(rawVal)] ?? Number(rawVal))
        : Number(rawVal);

      rawSum += recodedVal;
      camposUsados++;
    }

    if (camposUsados === 0) {
      result[dominio] = { score: null, label: DOMINIO_LABELS[dominio], camposUsados: 0, camposTotais };
      continue;
    }

    // Escala proporcional ao número de itens respondidos
    const minK = perMin * camposUsados;
    const maxK = perMax * camposUsados;
    const score = Math.round(((rawSum - minK) / (maxK - minK)) * 100);

    result[dominio] = {
      score: Math.max(0, Math.min(100, score)),
      label: DOMINIO_LABELS[dominio],
      camposUsados,
      camposTotais,
    };
  }

  return result;
}
